import type { ApplicationForm } from './form.types'

const form: ApplicationForm = {
  type: 'commitmentApplication',
  sections: [
    {
      name: 'Låntagare',
      description: 'Lägg till uppgifter om huvudlåntagaren och eventuella medlåntagare.',
      questions: ['Borrowers'],
    },
    {
      name: 'Kontantinsats',
      description:
        'Ange kundens kontantinsats — lånebeloppet räknas fram från bostadens uppskattade värde minus kontantinsatsen.',
      questions: ['CashContribution'],
    },
    {
      name: 'Hushåll',
      description: 'Lägg till personer i hushållet.',
      questions: ['HouseholdChildren'],
    },
    {
      name: 'Tillgångar & skulder',
      description: 'Lägg till hushållets fordon, tillgångar, lån och andra bostäder.',
      questions: ['HouseholdCars', 'CapitalAssets', 'OtherLoans', 'OtherProperties'],
    },
    {
      name: 'Lånelöfte',
      description: 'Ange uppskattade bostadsuppgifter för lånelöftet.',
      questions: [
        'CollateralValuation',
        'CommitmentPropertyType',
        'CommitmentSize',
        'CommitmentMonthlyFee',
        'CommitmentMunicipality',
      ],
    },
    {
      name: 'Kommentar',
      description: 'Lägg till intern information som är relevant för handläggningen.',
      questions: ['Comment'],
    },
  ],
}

export default form
